import React, { PureComponent } from 'react';
import Card from './Card';
import HtmlComponent from '../../features/HtmlComponent/HtmlComponent';
import { scrollToId } from '../../utils/scroll';

class DynamicFeatureBlock extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBackgroundColor: 'Citat-grå'
    };
  }

  componentDidMount() {
    const selectedItem =
      this.props.backgroundColor && this.props.backgroundColor.find(item => item.selected);
    const selectedBackgroundColor = (selectedItem && selectedItem.text) || 'Citat-grå';
    this.setState({ selectedBackgroundColor });
  }

  onClickScroll = () => scrollToId('formLink');

  render() {
    const { selectedBackgroundColor } = this.state;

    const backgroundClass =
      {
        'Citat-grå': 'dynamic-feature-block--dark-grey',
        Mellangrå: 'dynamic-feature-block--medium-grey',
        Ljusgrå: 'dynamic-feature-block--light-grey',
        Vit: 'dynamic-feature-block--white'
      }[selectedBackgroundColor] || 'dynamic-feature-block--dark-grey';

    const cssClass =
      selectedBackgroundColor === 'Citat-grå'
        ? 'light'
        : selectedBackgroundColor === 'Mellangrå'
        ? 'dark'
        : '';

    const {
      blockHeading,
      blockPreamble,
      mainBody,
      manualLink,
      buttonText,
      shouldScrollToForm
    } = this.props;
    const cards = this.props.dynamicBlockContainer;

    return (
      <div className={`dynamic-feature-block ${backgroundClass}`}>
        <div className="container--large">
          {blockHeading && <h2 className="h2">{blockHeading}</h2>}
          {blockPreamble && <p className="p p--lead">{blockPreamble}</p>}
          {mainBody && (
            <HtmlComponent
              html={mainBody}
              className={`dynamic-feature-block__rich-text ${cssClass}`}
            />
          )}
        </div>
        {cards && cards.length === 1 && cards[0].cardImage === null ? (
          <div
            className={`container--large dynamic-feature-block__inner-container dynamic-feature-block__inner-container_only-text--${cards.length}`}>
            {cards.map((card, index) => (
              <Card
                flip={false}
                key={index}
                imgURL={card.cardImage}
                texteditor={card.cardPreamble}
                buttonURL={`${card.pageToGetDataFrom ? card.pageToGetDataFrom : card.manualLink}${
                  card.shouldScrollToForm ? '#formLink' : ''
                }`}
                shouldScrollToForm={card.shouldScrollToForm}
                ButtonText={card.cardButtonText}
                numberOfCards={cards.length}
              />
            ))}
          </div>
        ) : (
          cards &&
          cards.length >= 1 && (
            <div
              className={`container--large dynamic-feature-block__inner-container dynamic-feature-block__inner-container--${cards.length}`}>
              {cards.map((card, index) => (
                <Card
                  flip={false}
                  key={index}
                  imgURL={card.cardImage}
                  texteditor={card.cardPreamble}
                  buttonURL={`${card.pageToGetDataFrom ? card.pageToGetDataFrom : card.manualLink}${
                    card.shouldScrollToForm ? '#formLink' : ''
                  }`}
                  ButtonText={card.cardButtonText}
                  numberOfCards={cards.length}
                  shouldScrollToForm={card.shouldScrollToForm}
                  pictureRightSide={card.flipPictureOnSingleCard}
                />
              ))}
            </div>
          )
        )}
        {buttonText && (
          <div className="container--large">
            <div className="dynamic-feature-block__button-container">
              {manualLink ? (
                <a href={manualLink}>
                  <div className={`dynamic-feature-block__button button ${cssClass}`}>
                    {buttonText}
                  </div>
                </a>
              ) : shouldScrollToForm ? (
                <div
                  className={`dynamic-feature-block__button button ${cssClass}`}
                  onClick={() => {
                    this.onClickScroll();
                  }}>
                  {buttonText}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DynamicFeatureBlock;
